import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { ScrollView, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import DaySectionComponent from "./DaySectionComponent"

const StudyProgramDisplayComponent = (props) => {
    const {
        studyProgram,
        isLoading,
        loadingMessage,
        onPress = () => {},
        highlightedChapterId,
        showChapterProgress = false
    } = props;

    const groupItemsByDay = (items) => {
        if (!items || items.length === 0) return []

        const grouped = items.reduce((acc, item) => {
            const day = item.day
            if (!acc[day]) {
                acc[day] = []
            }
            acc[day].push(item)
            return acc
        }, {})

        return Object.keys(grouped)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .map((day) => ({
                day: parseInt(day),
                items: grouped[day],
            }))
    }

    if (isLoading) {
        return (
            <View
                style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    paddingHorizontal: 20,
                }}
            >
                <ActivityIndicator
                    animating={true}
                    color={theme.colors.primary}
                    size="large"
                    style={{ marginBottom: 20 }}
                />
                <TextM
                    style={{
                        textAlign: "center",
                        color: theme.colors.primary,
                    }}
                    fontWeight="Medium"
                >
                    {loadingMessage}
                </TextM>
            </View>
        )
    }

    if (
        !studyProgram?.study_program_items ||
        studyProgram.study_program_items.length === 0
    ) {
        return (
            <View
                style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    paddingHorizontal: 20,
                }}
            >
                <TextM
                    style={{
                        textAlign: "center",
                        color: theme.colors.grey,
                    }}
                >
                    Aucun programme de révision trouvé
                </TextM>
            </View>
        )
    }

    const groupedItems = groupItemsByDay(studyProgram.study_program_items)

    return (
        <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ paddingHorizontal: 20, marginTop: 20 }}
        >
            {groupedItems.map((dayData) => (
                <DaySectionComponent
                    key={dayData.day}
                    dayData={dayData}
                    schoolSubjects={studyProgram.school_subjects}
                    startDate={studyProgram.start_date}
                    onPress={onPress}
                    highlightedChapterId={highlightedChapterId}
                    showChapterProgress={showChapterProgress}
                />
            ))}
            <View style={{ height: 50 }} />
        </ScrollView>
    )
}

export default StudyProgramDisplayComponent
